import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditEnlaceMenuComponent } from "./edit-enlace-menu/edit-enlace-menu.component";

@Component({
  selector: "app-enlace-menu",
  templateUrl: "./enlace-menu.component.html",
  styleUrls: ["./enlace-menu.component.scss"],
})
export class EnlaceMenuComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }
  openPanel() {
    this.customanpanel = EditEnlaceMenuComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
